import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '@zurich/common/hooks';
import { Stack } from '../../../atoms';
import { useIsMobile } from '../../../hooks';
import { styled } from '../../utils';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { Typography } from '../Typography';
import { breakpointFallback } from './Stepper';
export function StepNavigation({ ...props }) {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const nextButton = (_jsx(_Fragment, { children: isMobile ? (_jsx(IconButton, { outline: true, disabled: props.loading || !!props.disabledNext, variant: props.iconNextButton ?? 'arrow-right-2', size: "small", color: "primary", onClick: props.onClickNext })) : (_jsx(Button, { disabled: props.loading || !!props.disabledNext, loading: props.loadingNext, variant: "contained", color: "primary", onClick: props.onClickNext, children: props.labelNext
                ? props.labelNext
                : props.last
                    ? props.labelLast
                        ? props.labelLast
                        : t('common:button_label.finish')
                    : t('common:button_label.next') })) }));
    const prevButton = (_jsx(_Fragment, { children: isMobile ? (_jsx(IconButton, { outline: true, disabled: props.loading || !!props.disabledPrev, variant: props.iconPrevButton ?? 'arrow-left-2', size: "small", color: "primary", onClick: props.onClickPrev })) : (_jsx(Button, { disabled: props.loading || !!props.disabledPrev, loading: props.loadingPrev, variant: "outlined", color: "primary", onClick: props.onClickPrev, children: props.labelPrev || t('common:button_label.back') })) }));
    return (_jsxs(StepNavigationStyled, { sticky: props.sticky, breakpoint: props.breakpoint, buttonPosition: props.buttonPosition, children: [props.disabledNextReason ? (_jsxs(Stack, { alignItems: "flex-end", rowGap: 2, children: [nextButton, _jsx(Typography, { color: (theme) => theme.palette.error.main, children: props.disabledNextReason })] })) : (nextButton), !props.first &&
                (!props.hideCancelButton && props.disabledPrevReason ? (_jsxs(Stack, { alignItems: "flex-end", rowGap: 2, children: [prevButton, _jsx(Typography, { color: (theme) => theme.palette.error.main, children: props.disabledPrevReason })] })) : (_jsx(_Fragment, { children: !props.hideCancelButton && prevButton })))] }));
}
const StepNavigationStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'sticky' && prop !== 'breakpoint' && prop !== 'buttonPosition',
})(({ theme, sticky, breakpoint, buttonPosition }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: buttonPosition ?? 'space-between',
    paddingRight: 0,
    flexDirection: 'row-reverse',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    zIndex: 2,
    [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(4),
    },
    [theme.breakpoints.up(breakpoint ?? breakpointFallback)]: {
        paddingBottom: theme.spacing(1),
    },
    ...(sticky && {
        position: 'sticky',
        padding: theme.spacing(4, 0, 0),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 0),
        },
        bottom: 0,
        background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,0.76) 75%, rgba(255,255,255,0) 100%)',
        '&:after': {
            content: '""', // hack ->  prevent padding from parent shows scrolled content e.g. DialogContent
            position: 'absolute',
            height: theme.spacing(2),
            width: '100%',
            background: theme.palette.primary.contrastText,
            bottom: theme.spacing(-2),
        },
    }),
}));
